
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="marker-pin-close-container">
        <div class="header-container-new-marker-pin">
            <span><img src="../../assets/icons/marker_pin.png" alt="New Pin Icon" class="new-marker-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-marker-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.MARKER-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="marker-pin-info-container">

        <div class="marker-pin-container">
            <div class="marker-pin-headers">
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="marker-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="marker-pin-container">
            <ng-container>
                <p class="marker-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="marker-pin-info-text">{{pinObj.lat}}</p>
                <p class="marker-pin-info-text">{{pinObj.lng}}</p>
                <p class="marker-pin-info-text">{{pinObj.farm}}</p>
                <p class="marker-pin-info-text">{{pinObj.field}}</p>
                <p class="marker-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="marker-pin-input" appearance="outline">
            <mat-label>{{'NEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription">
            <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>

    <div class="marker-pin-btn-container">
        <div class="marker-pin-delete-btn-container">
            <button class="delete-marker-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
                <div class="marker-pin-btn-content">
                    <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-marker-pin-btn-icon">
                    <span><p class="marker-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <div class="marker-pin-update-btn-container">
            <button class="update-marker-pin-btn" mat-flat-button type="button" (click)="updatePin()">
                <div class="marker-pin-btn-content">
                    <span><p class="marker-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.UPDATE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <div class="marker-pin-open-marker-btn-container">
            <button class="open-marker-pin-btn" mat-flat-button type="button" (click)="openConvertPinDialog()">
                <div class="marker-pin-btn-content">
                    <span><p class="marker-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.COVERT-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>
   
    </div>

</form>

</div>


